import { MenuOptionModel } from '../../Models/MenuOptionModel';
import InputContentChip from './InputContentChip';

type MenuInputContentProps = {
	value: MenuOptionModel | undefined;
};

export default function MenuInputContent({ value }: MenuInputContentProps) {
	if (!value) {
		return null;
	}

	return <InputContentChip label={value.Title || 'Menu'} />;
}
